module.exports = __webpack_public_path__ + "static/media/Gilroy-Heavy.3f1816c1.eot";